import * as React from "react";

import Log, {Errors} from "@khan/logging";

// eslint-disable-next-line no-restricted-imports -- necessary for renderToast function to work
import deprecatedReactRender from "./deprecated-react-render.tsx";
import {ToastNotification} from "./toast-notification.tsx";
import {ChangesSavedNotification} from "./toast-notifications/changes-saved-notification.tsx";
import {ErrorNotification} from "./toast-notifications/error-notification.tsx";
import {InfoNotification} from "./toast-notifications/info-notification.tsx";

export function renderErrorToast(
    errorText: string,
    {testId}: {testId?: string} = {},
) {
    renderToast(<ErrorNotification content={errorText} />, {
        position: "bottom center",
        testId,
    });
}

export function renderInfoToast(
    content: React.ReactNode,
    {testId}: {testId?: string} = {},
) {
    renderToast(<InfoNotification content={content} />, {
        position: "bottom center",
        testId,
    });
}

export function renderChangesSavedToast({
    message,
    testId,
}: {message?: string; testId?: string} = {}) {
    renderToast(<ChangesSavedNotification message={message} />, {
        position: "bottom center",
        testId,
    });
}

let container;

export function renderToast(
    notification: React.ReactNode,
    options?: {position?: "top right" | "bottom center"; testId?: string},
) {
    if (!container) {
        container = document.createElement("div");
        document.body?.appendChild(container);
    }

    // TODO(erik): We should create new component for this in WB:
    // https://khanacademy.atlassian.net/browse/WB-663
    try {
        // Clear the container then re-render ToastNotification
        // TODO(FEI-3875) - move the toast to the app shell
        // This should be using React Portals
        deprecatedReactRender(<React.Fragment />, container, () => {
            deprecatedReactRender(
                <ToastNotification {...options}>
                    {notification}
                </ToastNotification>,
                container,
            );
        });
    } catch (e: any) {
        // NOTE (josh): For unclear reasons, errors have been known to be
        // silently swallowed. Adding a `Log.error` for help during dev/prod.
        Log.error("Error during renderToast", Errors.Internal, {cause: e});
    }
}
